import gql from 'graphql-tag';

const NAME = 'compositions_CaseRequestsPanel_requestLineOptionsQuery';

export default gql`
  query ${NAME} {
    rimType: __type(name: "RimType") { enumValues { name } }
    tirePosition: __type(name: "TirePosition") { enumValues { name } }
    tireCondition: __type(name: "TireCondition") { enumValues { name } }
    requestedAction: __type(name: "RequestedAction") { enumValues { name } }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestLineOptions/requestLineOptionsQuery.js